import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { FETCH_USER_ROLES } from 'gql/queries';
import { evaluate } from 'utilities/authUtils';

const Restricted = ({ children, allowFor }) => {

    const [getRoles, { loading, error, data }] = useLazyQuery(FETCH_USER_ROLES, {
        fetchPolicy: "cache-first",
        onError: err => console.log("Unable to determine user roles. restricted component not rendered")
    });

    useEffect(() => {
        if (allowFor) getRoles();
    }, [allowFor])

    if (!allowFor || (!loading && !error && (data && evaluate(data.userRoles, allowFor)))) return children;
    return null;
}

export default Restricted;